import { render, staticRenderFns } from "./BootstrapPhoneNumberInput.vue?vue&type=template&id=2c444432"
import script from "./BootstrapPhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./BootstrapPhoneNumberInput.vue?vue&type=script&lang=js"
import style0 from "./BootstrapPhoneNumberInput.vue?vue&type=style&index=0&id=2c444432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports